var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 3.70317C17.6061 3.98067 16.9334 4.16817 16.2261 4.25292C16.9559 3.81627 17.5018 3.12902 17.7621 2.31942C17.0765 2.72667 16.3261 3.01332 15.5436 3.16692C15.0174 2.60507 14.3204 2.23267 13.5609 2.10753C12.8013 1.98239 12.0217 2.11152 11.3431 2.47486C10.6644 2.83821 10.1247 3.41545 9.80775 4.11695C9.49078 4.81846 9.41428 5.60499 9.59013 6.35442C8.2009 6.28467 6.84185 5.92359 5.6012 5.2946C4.36055 4.66562 3.26601 3.78279 2.38863 2.70342C2.08863 3.22092 1.91613 3.82092 1.91613 4.45992C1.9158 5.03517 2.05746 5.60161 2.32854 6.10897C2.59962 6.61634 2.99175 7.04895 3.47013 7.36842C2.91534 7.35077 2.37279 7.20086 1.88763 6.93117V6.97617C1.88757 7.78298 2.16666 8.56496 2.67752 9.18942C3.18838 9.81388 3.89956 10.2424 4.69038 10.4022C4.17572 10.5415 3.63613 10.562 3.11238 10.4622C3.3355 11.1564 3.77013 11.7634 4.35541 12.1984C4.94069 12.6333 5.64732 12.8743 6.37638 12.8877C5.13876 13.8592 3.6103 14.3862 2.03688 14.3839C1.75817 14.384 1.47969 14.3677 1.20288 14.3352C2.79999 15.3621 4.65914 15.907 6.55788 15.9049C12.9854 15.9049 16.4991 10.5814 16.4991 5.96442C16.4991 5.81442 16.4954 5.66292 16.4886 5.51292C17.1721 5.01865 17.7621 4.4066 18.2309 3.70542L18.2324 3.70317Z",
    fill: "#D5D9DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.499756 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dc3b72e2bdf02e66142573f1bf3b9e86.svg";
export { ForwardRef as ReactComponent };